import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  // Функция для определения API URL на основе текущего домена
  const getApiUrl = () => {
    if (process.server) {
      // На сервере определяем URL на основе заголовка host
      const host = nuxtApp.ssrContext?.event.node.req.headers.host || ''
      
      if (host === 'yourservice.ae') {
        return {
            url: 'https://backend-prod-bhlfzy4vpq-ez.a.run.app/api',
            isProduction: true
        }
      } else {
        return {
            url: 'https://backend-dev-bhlfzy4vpq-ez.a.run.app/api',
            isProduction: false
        }
      }
    } else {
      // На клиенте определяем URL на основе текущего домена
      const hostname = window.location.hostname
      
      if (hostname === 'yourservice.ae') {
        return {
            url: 'https://backend-prod-bhlfzy4vpq-ez.a.run.app/api',
            isProduction: true
        }
      } else {
        return {
            url: 'https://backend-dev-bhlfzy4vpq-ez.a.run.app/api',
            isProduction: false
        }
      }
    }
  }

  config.public.baseURL = getApiUrl().url
  config.public.isProduction = getApiUrl().isProduction
  if(config.public.isProduction) {
    config.public.gtm.enabled = true;
  }
}) 